export function initRussianPhoneMask(selector = 'input.input[type="tel"]') {
    const inputs = document.querySelectorAll<HTMLInputElement>(selector);
    if (!inputs.length) return;

    const allowedKeyNames = new Set([
        'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
        'Home', 'End', 'Tab',
    ]);

    inputs.forEach((input) => {
        input.addEventListener('focus', () => {
            if (extractPhoneDigits(input.value).length === 0) {
                input.value = '+7 (';
                moveCursorToEnd(input);
            }
        });

        input.addEventListener('blur', () => {
            if (extractPhoneDigits(input.value).length === 0) {
                input.value = '';
            }
        });

        input.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.ctrlKey || e.metaKey) return;
            if (allowedKeyNames.has(e.key)) return;
            if (/^\d$/.test(e.key)) return;
            e.preventDefault();
        });

        input.addEventListener('paste', (e: ClipboardEvent) => {
            e.preventDefault();
            const paste = e.clipboardData?.getData('text') ?? '';
            const digits = extractPhoneDigits(paste);
            applyFormattedValue(input, digits);
        });

        input.addEventListener('input', () => {
            const digits = extractPhoneDigits(input.value);
            applyFormattedValue(input, digits);
        });

        // Если поле уже имеет значение (автозаполнение/SSR) — форматируем
        const initialDigits = extractPhoneDigits(input.value);
        if (initialDigits.length > 0) {
            applyFormattedValue(input, initialDigits);
        }
    });

    function extractPhoneDigits(raw: string): string {
        const onlyDigits = raw.replace(/\D/g, '');
        let digits = onlyDigits;

        if (digits.length > 0 && (digits[0] === '7' || digits[0] === '8')) {
            digits = digits.slice(1);
        }

        return digits.slice(0, 10);
    }

    function applyFormattedValue(el: HTMLInputElement, d: string) {
        if (d.length === 0) {
            el.value = '';
            return;
        }

        let formatted = '+7 (';

        if (d.length <= 3) {
            formatted = `+7 (${d}`;
        } else if (d.length <= 6) {
            formatted = `+7 (${d.slice(0, 3)}) ${d.slice(3)}`;
        } else if (d.length <= 8) {
            formatted = `+7 (${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
        } else {
            formatted = `+7 (${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6, 8)}-${d.slice(8, 10)}`;
        }

        el.value = formatted;
        moveCursorToEnd(el);
    }

    function moveCursorToEnd(el: HTMLInputElement) {
        requestAnimationFrame(() => {
            el.setSelectionRange(el.value.length, el.value.length);
        });
    }
}
